module.exports = __webpack_public_path__ + "media/images/square-9a9fad7e9a8db8e09e6b2287783a34ec.svg";